export default __webpack_public_path__ + "static/media/bannerAndServices.60448744.png";